export enum itemsName {
  numOfGuards = 'numOfGuards',
  attendance = 'attendance',
  liveTracking = 'liveTracking',
  reports = 'reports',
  branches = 'branches',
  numOfUsers = 'numOfUsers',
  ReceivingOffersFromClients = 'ReceivingOffersFromClients',
  numberOfJobsOffered = 'numberOfJobsOffered',
  numberOfEmploymentContracts = 'numberOfEmploymentContracts',
  technicalSupport = 'technicalSupport',
}
